import React from 'react';
import { EditorPrebuiltModule, EditorTextAlign } from '@dev/template-editor';
import { useTranslation } from 'react-i18next';
import { MainFeatureWithCTAPreview } from './preview';

export const useMainFeatureWithCTA = (): EditorPrebuiltModule => {
    const { t } = useTranslation();
    return {
        id: 'main-feature-with-call-to-action',
        title: t('mainfeaturewithcalltoaction'),
        icon: <MainFeatureWithCTAPreview />,
        data: {
            name: 'editor/onecolumnsblock-v1',
            attributes: {},
            innerBlocks: [
                [
                    {
                        name: 'editor/imageblock-v1',
                        attributes: {},
                    },
                    {
                        name: 'editor/headingblock-v1',
                        attributes: {
                            textAlign: EditorTextAlign.CENTER,
                            padding: { paddingLeft: 20, paddingBottom: 10, paddingRight: 20, paddingTop: 20 },
                            content: 'Heading',
                        },
                    },
                    {
                        name: 'editor/paragraphblock-v1',
                        attributes: {
                            content:
                                'This is the place for your content. Did you know that email marketing has been around for a long time and is cost-effective? Email marketing allows you to regularly stay in touch with customers and website visitors. Most marketers...',
                        },
                    },
                    {
                        name: 'editor/buttonblock-v1',
                        attributes: {
                            content: 'Button',
                        },
                    },
                ],
            ],
        },
    };
};
